<template>
  <div>
    <div class="header">
      <!-- 安全规则管理 -->
      <header-tag :title="'我的安全规则'"></header-tag>
      <div style="display:inline-block; margin-left:20px;">
        <a href="#" @click.prevent="createRule" class="blue-btn">新建规则</a>
      </div>
    </div>
    <!-- 表格部分 -->
    <div class="table-content">
      <!-- <table-list ref="tableList" @pagechange="getSafetyRulesList" @deleteAllRules="deleteAllRules"
        @rulesStatusAlls="rulesStatusAlls" @refresh="refresh" @openRule="openRule" :total="parseInt(total)"
        :page="parseInt(page)" :table-list="tableData.list" :loading="loading"></table-list> -->
      <table-list :refresh="refresh" ></table-list>
    </div>
  </div>
</template>

<script>
// 头部tag内容
import HeaderTag from '_c/tagTitle/headerTag'
// 网吧列表
import TableList from './table'
import { mapActions } from 'vuex'
import {
  getRuleManageList,
  delRule,
  enabledRule,
} from '@/requests/securityCenter'
export default {
  name: 'safetyRules',
  components: {
    HeaderTag,
    TableList,
  },
  data () {
    return {
      total: 0,
      page: 1,
      // tableData: {
      //   list: [],
      // },
      tableData: [],
      loading: false,
      refresh: new Date()
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      // vm.getSafetyRulesList(1)
    })
  },
  methods: {
    ...mapActions(['rule/actionSetRule']),
    // 获取所有网吧列表
    async getSafetyRulesList (current) {
      this.loading = true
      this.tableData = []
      let res = await getRuleManageList({
        current,
        size: 10,
      })
      this.loading = false
      res.data.records.forEach(element => {
        element.isOpen = false
        if (element.status == 1) {
          element.isOpen = true
        } else {
          element.isOpen = false
        }
      })

      if (current == 1) {
        this.tableData = res.data.records
      } else {
        res.data.records.forEach(el => {
          this.tableData.push(el)
        })
      }

      this.total = parseInt(res.data.total)
      this.page = parseInt(res.data.current)
      let data = {
        current: current,
        data: res.data.records
      }
      // this["rule/actionSetRule"](data)
    },
    // refresh (page) {
    //   if (page)
    //   {
    //     this.getSafetyRulesList(page);
    //   } else
    //   {
    //     this.getSafetyRulesList(this.page);
    //   }
    // },
    deleteAllRules () {
      if (this.$refs.tableList.selectedRuleIds().length == 0) {
        return window.$Message.show({
          title: '提示',
          type: 'error',
          msg: '请选择规则',
        })
      }
      window.$Message.show({
        title: '删除规则',
        type: 'info',
        msg:
          '你确定要将已选择的' +
          this.$refs.tableList.selectedRuleIds().length +
          '条规则删除掉吗？',
        cancleBtn: true,
        confirmFn: async () => {
          let res = await delRule({
            id: this.$refs.tableList.selectedRuleIds().join(','),
          })
          if (res.code === 200) {
            window.$Message.hide()
            this.getSafetyRulesList(
              this.$del.delPage(
                this.total,
                this.$refs.tableList.selectedRuleIds().length,
                30,
                this.page
              )
            )
          } else {
            window.$Message.hide()
            setTimeout(() => {
              window.$Message.show({
                title: '删除规则',
                type: 'error',
                msg: res.msg,
                confirmFn: () => {
                  window.$Message.hide()
                  window.$Message.confirmFn = null
                },
              })
            }, 100)
          }
        },
      })
    },
    rulesStatusAlls (val) {
      let text
      if (val == 1) {
        text = '启用'
      } else {
        text = '禁用'
      }
      if (this.$refs.tableList.selectedRuleIds().length == 0) {
        return window.$Message.show({
          title: '提示',
          type: 'error',
          msg: '请选择规则',
        })
      }
      window.$Message.show({
        title: text + '规则',
        type: 'info',
        msg:
          '你确定要将已选择的' +
          this.$refs.tableList.selectedRuleIds().length +
          '条规则' +
          text +
          '掉吗？',
        cancleBtn: true,
        confirmFn: async () => {
          let res = await enabledRule({
            id: this.$refs.tableList.selectedRuleIds().join(','),
            type: val,
          })
          if (res.code === 200) {
            window.$Message.hide()
            this.getSafetyRulesList(this.page)
          } else {
            window.$Message.hide()
            setTimeout(() => {
              window.$Message.show({
                title: text + '规则',
                type: 'error',
                msg: res.msg,
                confirmFn: () => {
                  window.$Message.hide()
                  window.$Message.confirmFn = null
                },
              })
            }, 100)
          }
        },
      })
    },
    async openRule (id, val) {
      let res = await enabledRule({
        id: id,
        type: val,
      })
      if (res.code === 200) {
        this.getSafetyRulesList(this.page)
      } else {
        /* eslint-disable */
      }
    },
    async createRule () {
      let res = await window.$modal.editRulesModal.show();
      console.log(res)
      if (res)
      {
        this.refresh = new Date()
        // this.getSafetyRulesList(1);
      }
    },
    async importRule () {
      let res = await window.$modal.importRule.show();
      if (res)
      {
        this.refresh = new Date()
        // console.log(123)
        // this.getSafetyRulesList(1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  padding-left: 30px;
  text-align: left;
  position: relative;
  z-index: 10;
  height: 70px;
  line-height: 70px;
  border-bottom: 1px solid #d9dee4;
}

.right {
  float: right;
  padding-right: 20px;

  a {
    margin-left: 6px;
    line-height: normal;
  }
}

.table-content {
  padding-top: 10px;
  padding-left: 30px;
  padding-right: 30px;
  table{
    width: 100%;
    overflow-x: auto;
  }
}

.table-pagination {
  text-align: right;
  padding-right: 80px;
  padding-top: 20px;

  >div {
    display: inline-block;
  }
}
</style>
